import React, { Component } from 'react'
import { BsFileArrowUpFill, BsFileArrowDownFill, BsGraphUp } from "react-icons/bs";
import { AiOutlineReload, AiOutlineSearch } from "react-icons/ai";
import { getInformationWithData, getInformationWithDataV3 } from '../../../services/CABE';
import "../../../css/general-style.css"
import '../../../css/dashboard.css'
import { Menu } from "../../../components/Menu/Menu";
import LoadingWindow from '../../../components/LoadingWindow';
import { getValueCookie } from '../../../services/cookieService';
//import { getIndexElement } from '../../../functions/searchInObject';
//DateFormatMAS90, FormatQueryReturnDate, getDateYearMonthDayDash
import { DateFormatMAS90, DeleteQueryFormat, formatInputDateQuerytoInput, FormatQueryReturnDate, getDateFromReports, getIntervalAbleDays, ReplaceDashForLateralBar } from '../../../functions/dateFormat';
//NumberFormat
import { NumberFormat, OrderArray } from '../../../functions/generalFunctions';
//import { pricesFormat } from '../../../functions/pricesFormat';
import ModalOrders from '../../../components/ModalComponent';
import { DayPerAdjustment, Inventory, InventoryProductLine } from './Class';
import { getIndexElement, getIndexElement2 } from '../../../functions/searchInObject';
import { pricesFormat } from '../../../functions/pricesFormat';
import ExcelDocument from '../../../components/ExcelDocument';
import { getDataSet } from '../../../functions/generateDataSetExcel';



export default class HistoryInventoryReport extends Component {
    constructor(props) {
        super(props)
        this.ModalLoading = React.createRef();
    }
    state = {
        showModal1: false,
        order: false,
        activeCycleTab: 'generalCycle',
        History: [],
        FilterHistory: [],
        Detail: [],
        FilterDetail: [],
        ProdLine: [],
        ProdLineFilter: [],
        InfoProdLine: {},
        CurrentInvent: {
            NoInventory: '',
            QuantityDays: '',
            CloseDate: '',
            QuantityItemsCount: 0,
            ValuedAccuracy: 0,
            BinaryAccuracy: 0,
            Adjustments: 0,
            KPI: 0,
            TotalQuantityItemsError: 0,
            TotalValuedInventory: 0,
            TotalQuantityItemsOk: 0,
            Detail: [],
            DaysPerAdjustmenst: [],
            AllErrorItems: [],
            AllWrongDifferences: []
        },
        FilterCurrentInvent: {
            NoInventory: '',
            QuantityDays: '',
            CloseDate: '',
            QuantityItemsCount: 0,
            ValuedAccuracy: 0,
            BinaryAccuracy: 0,
            Adjustments: 0,
            KPI: 0,
            TotalQuantityItemsError: 0,
            TotalValuedInventory: 0,
            TotalQuantityItemsOk: 0,
            Detail: [],
            DaysPerAdjustmenst: [],
            AllErrorItems: [],
            AllWrongDifferences: []
        }
    }
    OrderInformation(array, key, asc, type) {
        const order = OrderArray(array, key, asc)

        this.setState({ [type]: order, order: !asc })

    }
    Order(array, key, asc) {
        const order = OrderArray(array, key, asc)
        return order
    }
    OrderSpecificInformation(key, asc, type) {
        const temporal = this.state.FilterCurrentInvent
        temporal[type] = OrderArray(temporal[type], key, asc)
        this.setState({ FilterCurrentInvent: temporal, order: !asc })


    }

    handleModalClose = (modal) => {
        this.setState({ [modal]: false })
    }

    handleModalOpen = (modal) => {
        this.setState({ [modal]: true })
    }
    Contains(parametro, busqueda) {
        if (parametro && busqueda) {
            return parametro.toString().toLowerCase().includes(busqueda.toLocaleLowerCase())
        }
        return false
    }

    searchDetailCycleInventory = e => {
        const searchValue = e.target.value
        let Filter = []
        if (searchValue === '') {
            Filter = this.state.Detail
        } else {
            Filter = this.state.Detail.filter((detail) => {
                if (this.Contains(detail.Name, searchValue)) {
                    return detail
                } else {
                    return null
                }
            })
        }
        this.setState({ FilterDetail: Filter })
    }

    searchDetailErrorCycleInventory = e => {
        const searchValue = e.target.value
        let Filter = {}
        if (searchValue === '') {
            Filter = JSON.parse(JSON.stringify(this.state.CurrentInvent))
        } else {
            Filter = JSON.parse(JSON.stringify(this.state.FilterCurrentInvent))
            Filter.AllErrorItems = this.state.CurrentInvent.AllErrorItems.filter((detail) => {
                if (this.Contains(detail.ItemCode, searchValue) ||
                    this.Contains(detail.productLine, searchValue) ||
                    this.Contains(detail.Description, searchValue)) {
                    return detail
                } else {
                    return null
                }
            })
        }
        this.setState({ FilterCurrentInvent: Filter })
    }
    searchAllWrongDifferences = e => {
        const searchValue = e.target.value
        let Filter = {}
        if (searchValue === '') {
            Filter = JSON.parse(JSON.stringify(this.state.CurrentInvent))
        } else {
            Filter = JSON.parse(JSON.stringify(this.state.FilterCurrentInvent))
            Filter.AllWrongDifferences = this.state.CurrentInvent.AllWrongDifferences.filter((detail) => {
                if (this.Contains(detail.ItemCode, searchValue) ||
                    this.Contains(detail.productLine, searchValue) ||
                    this.Contains(detail.Description, searchValue)) {
                    return detail
                } else {
                    return null
                }
            })
        }
        this.setState({ FilterCurrentInvent: Filter })
    }

    searchProdLineFilter = e => {
        const searchValue = e.target.value
        let Filter = []
        if (searchValue === '') {
            Filter = this.state.ProdLine
        } else {
            Filter = this.state.ProdLine.filter((detail) => {
                if (this.Contains(detail.ItemCode, searchValue) ||
                    this.Contains(detail.productLine, searchValue) ||
                    this.Contains(detail.Description, searchValue)) {
                    return detail
                } else {
                    return null
                }
            })
        }
        this.setState({ ProdLineFilter: Filter })
    }

    async getDetailActualInventory() {
        this.ModalLoading.current.showState(true);
        const baseData = {
            idcompany: getValueCookie('CompanyId'),
            company: getValueCookie('Company'),
            ItemCode: '',
        }

        // 1. Fetch closed cycle headers
        const datos = await getInformationWithDataV3('/v3/invertory/oldCycleInventorys/post', baseData)
        if (!datos || !datos.data || datos.data.length === 0 || datos.status.code !== 1) {
            this.ModalLoading.current.showState(false);
            return;
        }

        // 2. Adjustments (WS) + item list (WS/RDS) sequentially — avoids WS collision
        const rangeData = {
            idcompany: baseData.idcompany,
            company: baseData.company,
            ItemCode: '',
            Start: ReplaceDashForLateralBar(formatInputDateQuerytoInput(datos.data[0].startDate)),
            End: ReplaceDashForLateralBar(formatInputDateQuerytoInput(datos.data[datos.data.length - 1].realFinishDate)),
        }
        const costs = await getInformationWithDataV3('/v3/adjustment/history/getByItemCode', rangeData)
        const itemsResp = await getInformationWithData('/Items/get', baseData)

        const costsData = (costs && Array.isArray(costs.data)) ? costs.data : []
        const itemsList = (itemsResp && itemsResp.status && itemsResp.status.code === 1 && Array.isArray(itemsResp.data))
            ? itemsResp.data
            : []

        // 3. P3 — fetch ALL cycle details in parallel instead of 40 sequential awaits
        const cycleRequests = datos.data.map(function(inventory) {
            return getInformationWithDataV3('/v3/inventory/cycledetail/post', {
                idcompany: rangeData.idcompany,
                company: rangeData.company,
                ItemCode: '',
                Start: rangeData.Start,
                End: rangeData.End,
                id: inventory.id,
            })
        })
        const cycleResults = await Promise.allSettled(cycleRequests)

        // 4. Process each cycle using pre-fetched data
        const ListofInventory = []

        for (let i = 0; i < datos.data.length; i++) {
            const inventory = datos.data[i]
            const cycleResult = cycleResults[i]
            if (cycleResult.status !== 'fulfilled') continue

            const detailInventory = cycleResult.value
            const detailData = (detailInventory && Array.isArray(detailInventory.data)) ? detailInventory.data : []

            // P2 — set Description from pre-fetched itemsList (replaces ItemDesc → /Items/get per cycle)
            for (let d = 0; d < detailData.length; d++) {
                const it = detailData[d]
                const itemIndex = getIndexElement(itemsList, 'itemCode', it.ItemCode)
                if (itemIndex !== -1) {
                    const raw = itemsList[itemIndex]
                    const desc = (!raw.completeDesc || raw.completeDesc === 'null')
                        ? raw.abbreviatedDesc
                        : raw.completeDesc
                    if (desc) it.Description = desc
                    it.LastDueDate = raw.LastDueDate
                }
            }

            const inv = new Inventory(inventory.CycleInfo, getIntervalAbleDays(inventory.realFinishDate, inventory.startDate), inventory.realFinishDate2)

            for (let j = 0; j < detailData.length; j++) {
                const detail = detailData[j]
                const index = getIndexElement(inv.Detail, 'Name', detail.productLine)
                const index2 = getIndexElement2(costsData, 'ItemCode', 'Date', detail.ItemCode, DeleteQueryFormat(detail.date))

                detail.TotalCost = index2 !== -1 ? costsData[index2].ExtendedCost : 0.00
                detail.MAS90Adjustment = index2 !== -1 ? costsData[index2].NewQuantity : 0
                detail.MAS90AdjCost = index2 !== -1 ? costsData[index2].ExtendedCost : 0.00
                inv.addAdjustment(index2 !== -1 ? costsData[index2].ExtendedCost : 0.00)

                if (index2 !== -1) {
                    const index3 = getIndexElement(inv.DaysPerAdjustmenst, 'Day', DateFormatMAS90(costsData[index2].Date))
                    if (index3 !== -1) {
                        inv.DaysPerAdjustmenst[index3].addValue(costsData[index2].ExtendedCost)
                    } else {
                        const newDayAdj = new DayPerAdjustment(DateFormatMAS90(costsData[index2].Date), inv.DaysPerAdjustmenst.length)
                        newDayAdj.addValue(costsData[index2].ExtendedCost)
                        inv.DaysPerAdjustmenst.push(newDayAdj)
                    }
                }

                if (index !== -1) {
                    detail.TotalVal = detail.realQuantity * detail.LastTotalUnitCost
                    detail.TotalAdjustment = detail.difference * detail.LastTotalUnitCost
                    inv.Detail[index].LastDate = FormatQueryReturnDate(detail.date)
                    inv.Detail[index].addItem()
                    inv.Detail[index].addCountItem()
                    inv.addItemCount()
                    detail.difference === 0 ? inv.Detail[index].addOkItem() : inv.Detail[index].addWrongItem()
                    detail.difference === 0 ? inv.addItemOk() : inv.addItemWrong()
                    detail.TotalVal = detail.realQuantity * detail.LastTotalUnitCost
                    detail.TotalAdjustment = detail.difference * detail.LastTotalUnitCost
                    inv.Detail[index].calculateBinaryAccuracy()
                    inv.Detail[index].calculateAdvance(detailData.length)
                    inv.Detail[index].calculateTotalCost(detail.TotalCost)
                    inv.Detail[index].addAcumulated(detail.TotalVal)
                    inv.Detail[index].ListProducts.push(detail)
                } else {
                    detail.TotalVal = detail.realQuantity * detail.LastTotalUnitCost
                    detail.TotalAdjustment = detail.difference * detail.LastTotalUnitCost
                    const newProdLine = new InventoryProductLine(detail.productLine)
                    newProdLine.LastDate = FormatQueryReturnDate(detail.date)
                    newProdLine.addAcumulated(detail.TotalVal)
                    newProdLine.addItem()
                    newProdLine.addCountItem()
                    inv.addItemCount()
                    detail.difference === 0 ? newProdLine.addOkItem() : newProdLine.addWrongItem()
                    detail.difference === 0 ? inv.addItemOk() : inv.addItemWrong()
                    newProdLine.calculateBinaryAccuracy()
                    newProdLine.calculateAdvance(detailData.length)
                    newProdLine.calculateTotalCost(detail.TotalCost)
                    newProdLine.ListProducts.push(detail)
                    inv.Detail.push(newProdLine)
                }

                if (detail.difference !== 0) {
                    inv.AllErrorItems.push(detail)
                }
                if (detail.difference !== detail.MAS90Adjustment) {
                    inv.AllWrongDifferences.push(detail)
                }
            }

            inv.calculateBinaryAccuracy()
            inv.calculateTotalValuedInventory()
            inv.calculateValuedAccuracy()
            inv.calculateKPI()
            ListofInventory.push(inv)
        }

        this.setState({ History: ListofInventory, FilterHistory: ListofInventory })
        this.ModalLoading.current.showState(false);
    }



    SelectHistory(det) {
        const hasDetail = det.Detail && det.Detail.length > 0
        this.setState({
            CurrentInvent: det,
            FilterCurrentInvent: det,
            Detail: det.Detail,
            FilterDetail: det.Detail,
            activeCycleTab: hasDetail ? 'detailCycle' : 'generalCycle',
        })
    }
    SelectSpecificProdLine(det) {
        this.setState({ ProdLine: det.ListProducts, ProdLineFilter: det.ListProducts, InfoProdLine: det })

        this.handleModalOpen("showModal1")
    }


    render() {
        const hasData = this.state.History.length > 0
        const hasDetail = this.state.Detail.length > 0
        const sortArrows = <span style={{ marginLeft: '3px', opacity: 0.5 }}><BsFileArrowUpFill size={9} /><BsFileArrowDownFill size={9} /></span>

        // Row color by KPI/accuracy
        const kpiRowClass = (val) => {
            const n = Number(val)
            if (n >= 90) return 'status-success'
            if (n >= 70) return 'status-warning'
            return 'status-danger'
        }
        const diffRowClass = (diff, mas90) => diff !== mas90 ? 'status-danger' : ''

        return (
            <div className="dash-page" style={{ paddingTop: '30px' }}>
                {this.props.showMenu && <Menu />}
                <LoadingWindow ref={this.ModalLoading} />

                {/* Hero */}
                <div style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e3a5f 50%, #2563EB 100%)', padding: '3rem 2rem', display: 'flex', alignItems: 'center', gap: '1rem', flexWrap: 'wrap' }}>
                    <div style={{ background: 'rgba(255,255,255,0.12)', borderRadius: '12px', padding: '0.75rem', display: 'flex' }}>
                        <BsGraphUp style={{ color: 'white', fontSize: '1.75rem' }} />
                    </div>
                    <div style={{ flex: 1 }}>
                        <h1 style={{ color: 'white', fontWeight: 800, fontSize: '1.375rem', margin: 0 }}>History KPI Inventory</h1>
                        <p style={{ color: 'rgba(255,255,255,0.6)', margin: 0, fontSize: '0.8rem' }}>
                            {hasData ? `${this.state.FilterHistory.length} cycles loaded` : 'Load data to view historical inventory KPIs'}
                        </p>
                    </div>
                    <button onClick={() => this.getDetailActualInventory()}
                        style={{ background: 'rgba(255,255,255,0.15)', border: '1px solid rgba(255,255,255,0.3)', borderRadius: '8px', color: 'white', fontWeight: 700, padding: '0.45rem 1rem', fontSize: '0.875rem', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: '0.4rem' }}>
                        <AiOutlineReload /> Load Data
                    </button>
                </div>

                <div style={{ padding: '1.5rem 2rem' }}>
                    {!hasData ? (
                        <div style={{ textAlign: 'center', padding: '4rem 2rem', color: '#94A3B8' }}>
                            <BsGraphUp style={{ fontSize: '3rem', opacity: 0.2, marginBottom: '1rem' }} />
                            <p style={{ fontSize: '0.9rem', fontWeight: 500 }}>Click <strong>Load Data</strong> to fetch historical inventory cycle KPIs.</p>
                            <p style={{ fontSize: '0.8rem', color: '#CBD5E1', marginTop: '0.5rem' }}>Note: loading may take a moment while fetching adjustment data from MAS90.</p>
                        </div>
                    ) : (
                    <div>

                    {/* Tabs — design system pill style */}
                    <div className="card" style={{ borderRadius: '12px', border: '1px solid #E2E8F0', overflow: 'hidden' }}>
                        <div style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)', padding: '0.75rem 1.25rem', display: 'flex', gap: '0.4rem', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between' }}>
                            <div className="nav" role="tablist" style={{ display: 'flex', gap: '0.4rem', flexWrap: 'wrap' }}>
                                {[
                                    { id: 'generalCycle', label: 'All Cycles', always: true },
                                    { id: 'detailCycle', label: 'Detail', hidden: !hasDetail, btnId: 'detailCycleInv' },
                                    { id: 'errorItems', label: 'Wrong Items', hidden: !hasDetail, btnId: 'errorItemsInv' },
                                    { id: 'adjustmentsError', label: 'Adj. Mismatch', hidden: !hasDetail, btnId: 'adjustmentsErrorInv' },
                                ].filter(t => t.always || !t.hidden).map((t) => {
                                    const isActive = this.state.activeCycleTab === t.id
                                    return (
                                        <button key={t.id} id={t.btnId}
                                            type="button" role="tab" aria-selected={isActive}
                                            onClick={() => this.setState({ activeCycleTab: t.id })}
                                            style={{ padding: '0.3rem 0.875rem', borderRadius: '6px', border: 'none', background: isActive ? 'rgba(255,255,255,0.9)' : 'rgba(255,255,255,0.12)', color: isActive ? '#0f172a' : 'white', fontWeight: 700, fontSize: '0.8rem', cursor: 'pointer' }}>
                                            {t.label}
                                        </button>
                                    )
                                })}
                            </div>
                            <ExcelDocument
                                hidden={false}
                                archname={'History KPI Cycle Inventory ' + getValueCookie('Company') + ' ' + getDateFromReports()}
                                sheetname={'History KPI Cycle Inventory ' + getValueCookie('Company')}
                                data={getDataSet(this.state.FilterHistory, ['Cycle', 'Days', 'End Date', 'Count Items', 'Binary Accuracy', 'Valued Accuracy', 'Total Valued ($)', 'Adjustments ($)', 'KPI'], ['NoInventory', 'QuantityDays', 'CloseDate', 'QuantityItemsCount', 'BinaryAccuracy', 'ValuedAccuracy', 'TotalValuedInventory', 'Adjustments', 'KPI'])}
                            />
                        </div>

                        <div className="tab-content" id="allCycleHeader">

                            {/* TAB 1 — All Cycles */}
                            <div className={`tab-pane fade ${this.state.activeCycleTab === 'generalCycle' ? 'show active' : ''}`} id="generalCycle" role="tabpanel">
                                <div className="tableFixHeadSmall">
                                    <table className='table table-clean mb-0'>
                                        <thead>
                                            <tr className="text-center">
                                                <th onClick={() => this.OrderInformation(this.state.FilterHistory, 'NoInventory', this.state.order, 'FilterHistory')} style={{ cursor: 'pointer' }}>Cycle {sortArrows}</th>
                                                <th onClick={() => this.OrderInformation(this.state.FilterHistory, 'QuantityDays', this.state.order, 'FilterHistory')} style={{ cursor: 'pointer' }}>Days {sortArrows}</th>
                                                <th onClick={() => this.OrderInformation(this.state.FilterHistory, 'CloseDate', this.state.order, 'FilterHistory')} style={{ cursor: 'pointer' }}>End Date {sortArrows}</th>
                                                <th onClick={() => this.OrderInformation(this.state.FilterHistory, 'QuantityItemsCount', this.state.order, 'FilterHistory')} style={{ cursor: 'pointer' }}>Items {sortArrows}</th>
                                                <th onClick={() => this.OrderInformation(this.state.FilterHistory, 'BinaryAccuracy', this.state.order, 'FilterHistory')} style={{ cursor: 'pointer' }}>Binary Acc. {sortArrows}</th>
                                                <th onClick={() => this.OrderInformation(this.state.FilterHistory, 'ValuedAccuracy', this.state.order, 'FilterHistory')} style={{ cursor: 'pointer' }}>Valued Acc. {sortArrows}</th>
                                                <th className="text-end" onClick={() => this.OrderInformation(this.state.FilterHistory, 'TotalValuedInventory', this.state.order, 'FilterHistory')} style={{ cursor: 'pointer' }}>Total Valued {sortArrows}</th>
                                                <th className="text-end" onClick={() => this.OrderInformation(this.state.FilterHistory, 'Adjustments', this.state.order, 'FilterHistory')} style={{ cursor: 'pointer' }}>Adjustments {sortArrows}</th>
                                                <th onClick={() => this.OrderInformation(this.state.FilterHistory, 'KPI', this.state.order, 'FilterHistory')} style={{ cursor: 'pointer' }}>KPI {sortArrows}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.FilterHistory.map((det, d) => (
                                                <tr key={d} className={kpiRowClass(det.KPI)} onClick={() => this.SelectHistory(det)} style={{ cursor: 'pointer' }}>
                                                    <td style={{ fontWeight: 700, color: '#334155' }}>{det.NoInventory}</td>
                                                    <td className="text-center">{det.QuantityDays}</td>
                                                    <td className="text-center" style={{ fontSize: '0.875rem', color: '#64748B' }}>{det.CloseDate}</td>
                                                    <td className="text-center">{det.QuantityItemsCount}</td>
                                                    <td className="text-center">
                                                        <span style={{ fontWeight: 700, color: Number(det.BinaryAccuracy) >= 90 ? '#059669' : Number(det.BinaryAccuracy) >= 70 ? '#D97706' : '#DC2626' }}>
                                                            {pricesFormat(det.BinaryAccuracy)}%
                                                        </span>
                                                    </td>
                                                    <td className="text-center">
                                                        <span style={{ fontWeight: 700, color: Number(det.ValuedAccuracy) >= 90 ? '#059669' : Number(det.ValuedAccuracy) >= 70 ? '#D97706' : '#DC2626' }}>
                                                            {pricesFormat(det.ValuedAccuracy)}%
                                                        </span>
                                                    </td>
                                                    <td className="text-end" style={{ fontWeight: 600 }}>$ {NumberFormat(pricesFormat(det.TotalValuedInventory))}</td>
                                                    <td className="text-end" style={{ color: '#DC2626', fontWeight: 600 }}>$ {NumberFormat(pricesFormat(det.Adjustments))}</td>
                                                    <td className="text-center">
                                                        <span style={{ background: Number(det.KPI) >= 90 ? 'rgba(16,185,129,0.1)' : Number(det.KPI) >= 70 ? 'rgba(245,158,11,0.1)' : 'rgba(239,68,68,0.1)', color: Number(det.KPI) >= 90 ? '#059669' : Number(det.KPI) >= 70 ? '#D97706' : '#DC2626', border: `1px solid ${Number(det.KPI) >= 90 ? '#A7F3D0' : Number(det.KPI) >= 70 ? '#FDE68A' : '#FECACA'}`, borderRadius: '6px', padding: '2px 8px', fontSize: '0.8rem', fontWeight: 800 }}>
                                                            {NumberFormat(pricesFormat(det.KPI))}%
                                                        </span>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                        <tfoot className="tfoot"><tr><td colSpan={9} style={{ color: '#94A3B8', fontSize: '0.78rem' }}>Click a row to view its product line detail</td></tr></tfoot>
                                    </table>
                                </div>
                            </div>

                            {/* TAB 2 — Detail */}
                            <div className={`tab-pane fade ${this.state.activeCycleTab === 'detailCycle' ? 'show active' : ''}`} id="detailCycle" role="tabpanel">
                                <div style={{ padding: '0.875rem 1.25rem', borderBottom: '1px solid #E2E8F0', display: 'flex', gap: '0.75rem', alignItems: 'center' }}>
                                    <div style={{ position: 'relative', flex: 1 }}>
                                        <AiOutlineSearch style={{ position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)', color: '#94A3B8' }} />
                                        <input onChange={this.searchDetailCycleInventory} className="form-control form-control-sm" placeholder='Search by Product Line' id='searchDetailCycleInventory' type="text" style={{ paddingLeft: '2rem', borderRadius: '8px', border: '1.5px solid #E2E8F0' }} />
                                    </div>
                                    <ExcelDocument hidden={false} archname={'Cycle KPI Product Lines ' + getValueCookie('Company') + ' ' + getDateFromReports()} sheetname={'KPI Product Lines'} data={getDataSet(this.state.FilterDetail, ['Product Line', 'Date', 'Total Items', 'Ok Items', 'Error Items', 'Binary Accuracy', 'Valued Accuracy', '% Advance', 'Total Accum ($)', 'Total Valued ($)'], ['Name', 'LastDate', 'TotalItem', 'TotalOKItem', 'TotalWrongItem', 'BinaryAccuracy', 'ValuedAccuracy', 'Advance', 'TotalCost', 'Accumulated'])} />
                                </div>
                                <div className="tableFixHeadSmall">
                                    <table className='table table-clean mb-0'>
                                        <thead>
                                            <tr className="text-center">
                                                <th onClick={() => this.OrderInformation(this.state.FilterDetail, 'Name', this.state.order, 'FilterDetail')} style={{ cursor: 'pointer' }}>Product Line {sortArrows}</th>
                                                <th onClick={() => this.OrderInformation(this.state.FilterDetail, 'LastDate', this.state.order, 'FilterDetail')} style={{ cursor: 'pointer' }}>Date {sortArrows}</th>
                                                <th onClick={() => this.OrderInformation(this.state.FilterDetail, 'TotalItem', this.state.order, 'FilterDetail')} style={{ cursor: 'pointer' }}>Total {sortArrows}</th>
                                                <th onClick={() => this.OrderInformation(this.state.FilterDetail, 'TotalOKItem', this.state.order, 'FilterDetail')} style={{ cursor: 'pointer' }}>OK {sortArrows}</th>
                                                <th onClick={() => this.OrderInformation(this.state.FilterDetail, 'TotalWrongItem', this.state.order, 'FilterDetail')} style={{ cursor: 'pointer' }}>Errors {sortArrows}</th>
                                                <th onClick={() => this.OrderInformation(this.state.FilterDetail, 'BinaryAccuracy', this.state.order, 'FilterDetail')} style={{ cursor: 'pointer' }}>Binary Acc. {sortArrows}</th>
                                                <th onClick={() => this.OrderInformation(this.state.FilterDetail, 'ValuedAccuracy', this.state.order, 'FilterDetail')} style={{ cursor: 'pointer' }}>Valued Acc. {sortArrows}</th>
                                                <th onClick={() => this.OrderInformation(this.state.FilterDetail, 'Advance', this.state.order, 'FilterDetail')} style={{ cursor: 'pointer' }}>Advance {sortArrows}</th>
                                                <th className="text-end" onClick={() => this.OrderInformation(this.state.FilterDetail, 'TotalCost', this.state.order, 'FilterDetail')} style={{ cursor: 'pointer' }}>Accum. {sortArrows}</th>
                                                <th className="text-end" onClick={() => this.OrderInformation(this.state.FilterDetail, 'Accumulated', this.state.order, 'FilterDetail')} style={{ cursor: 'pointer' }}>Valued {sortArrows}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.FilterDetail.map((proLine, i) => (
                                                <tr key={i} className={kpiRowClass(proLine.BinaryAccuracy)} onClick={() => this.SelectSpecificProdLine(proLine)} style={{ cursor: 'pointer' }}>
                                                    <td style={{ fontWeight: 600, color: '#334155' }}>{proLine.Name}</td>
                                                    <td className="text-center" style={{ fontSize: '0.8rem', color: '#64748B' }}>{proLine.LastDate}</td>
                                                    <td className="text-center">{proLine.TotalItem}</td>
                                                    <td className="text-center" style={{ color: '#059669', fontWeight: 600 }}>{proLine.TotalOKItem}</td>
                                                    <td className="text-center" style={{ color: '#DC2626', fontWeight: 600 }}>{proLine.TotalWrongItem}</td>
                                                    <td className="text-center" style={{ fontWeight: 700, color: Number(proLine.BinaryAccuracy) >= 90 ? '#059669' : Number(proLine.BinaryAccuracy) >= 70 ? '#D97706' : '#DC2626' }}>{pricesFormat(proLine.BinaryAccuracy)}%</td>
                                                    <td className="text-center" style={{ fontWeight: 700, color: Number(proLine.ValuedAccuracy) >= 90 ? '#059669' : Number(proLine.ValuedAccuracy) >= 70 ? '#D97706' : '#DC2626' }}>{pricesFormat(proLine.ValuedAccuracy)}%</td>
                                                    <td className="text-center">{pricesFormat(proLine.Advance)}%</td>
                                                    <td className="text-end">$ {NumberFormat(pricesFormat(proLine.TotalCost))}</td>
                                                    <td className="text-end" style={{ fontWeight: 600 }}>$ {NumberFormat(pricesFormat(proLine.Accumulated))}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                        <tfoot className="tfoot">
                                            <tr>
                                                <td>Totals</td>
                                                <td></td>
                                                <td className="text-center" style={{ fontWeight: 700 }}>{NumberFormat(Number(this.state.CurrentInvent.QuantityItemsCount))}</td>
                                                <td className="text-center" style={{ fontWeight: 700, color: '#059669' }}>{this.state.CurrentInvent.TotalQuantityItemsOk}</td>
                                                <td className="text-center" style={{ fontWeight: 700, color: '#DC2626' }}>{this.state.CurrentInvent.TotalQuantityItemsError}</td>
                                                <td className="text-center" style={{ fontWeight: 700 }}>{pricesFormat(this.state.CurrentInvent.BinaryAccuracy)}%</td>
                                                <td className="text-center" style={{ fontWeight: 700 }}>{pricesFormat(this.state.CurrentInvent.ValuedAccuracy)}%</td>
                                                <td></td>
                                                <td className="text-end" style={{ fontWeight: 700 }}>$ {NumberFormat(pricesFormat(this.state.CurrentInvent.Adjustments))}</td>
                                                <td className="text-end" style={{ fontWeight: 700 }}>$ {NumberFormat(pricesFormat(this.state.CurrentInvent.TotalValuedInventory))}</td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                            </div>

                            {/* TAB 3 — Wrong Items */}
                            <div className={`tab-pane fade ${this.state.activeCycleTab === 'errorItems' ? 'show active' : ''}`} id="errorItems" role="tabpanel">
                                <div style={{ padding: '0.875rem 1.25rem', borderBottom: '1px solid #E2E8F0', display: 'flex', gap: '0.75rem', alignItems: 'center' }}>
                                    <div style={{ position: 'relative', flex: 1 }}>
                                        <AiOutlineSearch style={{ position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)', color: '#94A3B8' }} />
                                        <input onChange={this.searchDetailErrorCycleInventory} className="form-control form-control-sm" placeholder='Search by Item Code, Product Line, Description' id='searchDetailErrorCycleInventory' type="text" style={{ paddingLeft: '2rem', borderRadius: '8px', border: '1.5px solid #E2E8F0' }} />
                                    </div>
                                    <ExcelDocument hidden={false} archname={'Wrong Items ' + getValueCookie('Company') + ' ' + getDateFromReports()} sheetname={'Wrong Items'} data={getDataSet(this.state.FilterCurrentInvent.AllErrorItems, ['Item Code', 'Product Line', 'Description', 'BIN', 'System Qty', 'Real Qty', 'System Diff', 'MAS90 Diff', 'Total Cost Sys', 'Total Cost MAS90', 'Total Valued', 'Date', 'Counted By', 'Comment'], ['ItemCode', 'productLine', 'Description', 'BIN', 'systemQuantity', 'realQuantity', 'difference', 'MAS90Adjustment', 'TotalAdjustment', 'MAS90AdjCost', 'TotalVal', 'date', 'countBy', 'comentary'])} />
                                </div>
                                <div className="tableFixHeadSmall">
                                    <table className='table table-clean mb-0'>
                                        <thead>
                                            <tr className="text-center">
                                                <th onClick={() => this.OrderSpecificInformation('ItemCode', this.state.order, 'AllErrorItems')} style={{ cursor: 'pointer' }}>Item Code {sortArrows}</th>
                                                <th onClick={() => this.OrderSpecificInformation('productLine', this.state.order, 'AllErrorItems')} style={{ cursor: 'pointer' }}>Product Line {sortArrows}</th>
                                                <th className="text-start" onClick={() => this.OrderSpecificInformation('Description', this.state.order, 'AllErrorItems')} style={{ cursor: 'pointer' }}>Description {sortArrows}</th>
                                                <th onClick={() => this.OrderSpecificInformation('BIN', this.state.order, 'AllErrorItems')} style={{ cursor: 'pointer' }}>BIN {sortArrows}</th>
                                                <th onClick={() => this.OrderSpecificInformation('systemQuantity', this.state.order, 'AllErrorItems')} style={{ cursor: 'pointer' }}>Sys Qty {sortArrows}</th>
                                                <th onClick={() => this.OrderSpecificInformation('realQuantity', this.state.order, 'AllErrorItems')} style={{ cursor: 'pointer' }}>Real Qty {sortArrows}</th>
                                                <th onClick={() => this.OrderSpecificInformation('difference', this.state.order, 'AllErrorItems')} style={{ cursor: 'pointer' }}>Sys Diff {sortArrows}</th>
                                                <th onClick={() => this.OrderSpecificInformation('MAS90Adjustment', this.state.order, 'AllErrorItems')} style={{ cursor: 'pointer' }}>MAS90 Diff {sortArrows}</th>
                                                <th className="text-end">Sys Cost</th>
                                                <th className="text-end">MAS90 Cost</th>
                                                <th className="text-end">Valued</th>
                                                <th>Date</th>
                                                <th>Counted By</th>
                                                <th className="text-start">Comment</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.FilterCurrentInvent.AllErrorItems.map((proLine, i) => (
                                                <tr key={i} className={proLine.difference !== proLine.MAS90Adjustment ? 'status-danger' : 'status-warning'}>
                                                    <td>
                                                        <span style={{ background: 'rgba(37,99,235,0.08)', color: '#1e40af', border: '1px solid #BFDBFE', borderRadius: '6px', padding: '2px 7px', fontSize: '0.72rem', fontWeight: 700 }}>{proLine.ItemCode}</span>
                                                    </td>
                                                    <td style={{ fontSize: '0.8rem', color: '#64748B' }}>{proLine.productLine}</td>
                                                    <td className="text-start" style={{ fontSize: '0.875rem' }}>{proLine.Description}</td>
                                                    <td className="text-center">{proLine.BIN && proLine.BIN !== 'null' ? proLine.BIN : '—'}</td>
                                                    <td className="text-center">{proLine.systemQuantity}</td>
                                                    <td className="text-center">{proLine.realQuantity}</td>
                                                    <td className="text-center" style={{ fontWeight: 700, color: proLine.difference !== 0 ? '#DC2626' : '#059669' }}>{proLine.difference}</td>
                                                    <td className="text-center" style={{ fontWeight: 700, color: proLine.MAS90Adjustment !== 0 ? '#DC2626' : '#059669' }}>{proLine.MAS90Adjustment}</td>
                                                    <td className="text-end">$ {pricesFormat(proLine.TotalAdjustment)}</td>
                                                    <td className="text-end">$ {pricesFormat(proLine.MAS90AdjCost)}</td>
                                                    <td className="text-end" style={{ fontWeight: 600 }}>$ {pricesFormat(proLine.TotalVal)}</td>
                                                    <td style={{ fontSize: '0.8rem', color: '#64748B' }}>{proLine.date ? FormatQueryReturnDate(proLine.date) : '—'}</td>
                                                    <td style={{ fontSize: '0.8rem', color: '#64748B' }}>{proLine.countBy || '—'}</td>
                                                    <td className="text-start" style={{ fontSize: '0.8rem', color: '#64748B' }}>{proLine.comentary || '—'}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            {/* TAB 4 — Not Equal Adjustments */}
                            <div className={`tab-pane fade ${this.state.activeCycleTab === 'adjustmentsError' ? 'show active' : ''}`} id="adjustmentsError" role="tabpanel">
                                <div style={{ padding: '0.875rem 1.25rem', borderBottom: '1px solid #E2E8F0', display: 'flex', gap: '0.75rem', alignItems: 'center' }}>
                                    <div style={{ position: 'relative', flex: 1 }}>
                                        <AiOutlineSearch style={{ position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)', color: '#94A3B8' }} />
                                        <input onChange={this.searchAllWrongDifferences} className="form-control form-control-sm" placeholder='Search by Item Code, Product Line, Description' id='searchAllWrongDifferences' type="text" style={{ paddingLeft: '2rem', borderRadius: '8px', border: '1.5px solid #E2E8F0' }} />
                                    </div>
                                    <ExcelDocument hidden={false} archname={'Adj Mismatch ' + getValueCookie('Company') + ' ' + getDateFromReports()} sheetname={'Adjustment Mismatch'} data={getDataSet(this.state.FilterCurrentInvent.AllWrongDifferences, ['Item Code', 'Product Line', 'Description', 'BIN', 'System Qty', 'Real Qty', 'System Diff', 'MAS90 Diff', 'Total Cost Sys', 'Total Cost MAS90', 'Total Valued', 'Date', 'Counted By', 'Comment'], ['ItemCode', 'productLine', 'Description', 'BIN', 'systemQuantity', 'realQuantity', 'difference', 'MAS90Adjustment', 'TotalAdjustment', 'MAS90AdjCost', 'TotalVal', 'date', 'countBy', 'comentary'])} />
                                </div>
                                <div className="tableFixHeadSmall">
                                    <table className='table table-clean mb-0'>
                                        <thead>
                                            <tr className="text-center">
                                                <th onClick={() => this.OrderSpecificInformation('ItemCode', this.state.order, 'AllWrongDifferences')} style={{ cursor: 'pointer' }}>Item Code {sortArrows}</th>
                                                <th onClick={() => this.OrderSpecificInformation('productLine', this.state.order, 'AllWrongDifferences')} style={{ cursor: 'pointer' }}>Product Line {sortArrows}</th>
                                                <th className="text-start" onClick={() => this.OrderSpecificInformation('Description', this.state.order, 'AllWrongDifferences')} style={{ cursor: 'pointer' }}>Description {sortArrows}</th>
                                                <th>BIN</th>
                                                <th>Sys Qty</th><th>Real Qty</th>
                                                <th onClick={() => this.OrderSpecificInformation('difference', this.state.order, 'AllWrongDifferences')} style={{ cursor: 'pointer' }}>Sys Diff {sortArrows}</th>
                                                <th onClick={() => this.OrderSpecificInformation('MAS90Adjustment', this.state.order, 'AllWrongDifferences')} style={{ cursor: 'pointer' }}>MAS90 Diff {sortArrows}</th>
                                                <th className="text-end">Sys Cost</th><th className="text-end">MAS90 Cost</th><th className="text-end">Valued</th>
                                                <th>Date</th><th>Counted By</th><th className="text-start">Comment</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.FilterCurrentInvent.AllWrongDifferences.map((proLine, i) => (
                                                <tr key={i} className="status-danger">
                                                    <td>
                                                        <span style={{ background: 'rgba(37,99,235,0.08)', color: '#1e40af', border: '1px solid #BFDBFE', borderRadius: '6px', padding: '2px 7px', fontSize: '0.72rem', fontWeight: 700 }}>{proLine.ItemCode}</span>
                                                    </td>
                                                    <td style={{ fontSize: '0.8rem', color: '#64748B' }}>{proLine.productLine}</td>
                                                    <td className="text-start" style={{ fontSize: '0.875rem' }}>{proLine.Description}</td>
                                                    <td className="text-center">{proLine.BIN && proLine.BIN !== 'null' ? proLine.BIN : '—'}</td>
                                                    <td className="text-center">{proLine.systemQuantity}</td>
                                                    <td className="text-center">{proLine.realQuantity}</td>
                                                    <td className="text-center" style={{ fontWeight: 700, color: '#DC2626' }}>{proLine.difference}</td>
                                                    <td className="text-center" style={{ fontWeight: 700, color: '#D97706' }}>{proLine.MAS90Adjustment}</td>
                                                    <td className="text-end">$ {pricesFormat(proLine.TotalAdjustment)}</td>
                                                    <td className="text-end">$ {pricesFormat(proLine.MAS90AdjCost)}</td>
                                                    <td className="text-end" style={{ fontWeight: 600 }}>$ {pricesFormat(proLine.TotalVal)}</td>
                                                    <td style={{ fontSize: '0.8rem', color: '#64748B' }}>{proLine.date ? FormatQueryReturnDate(proLine.date) : '—'}</td>
                                                    <td style={{ fontSize: '0.8rem', color: '#64748B' }}>{proLine.countBy || '—'}</td>
                                                    <td className="text-start" style={{ fontSize: '0.8rem', color: '#64748B' }}>{proLine.comentary || '—'}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    </div>
                    )}
                </div>

                {/* Modal — Product Line Detail */}
                <ModalOrders title={'Product Line: ' + this.state.InfoProdLine.Name} show={this.state.showModal1} close={(modal = "showModal1") => this.handleModalClose(modal)}>
                    {/* Header stats */}
                    <div className="pol-card__grid mb-3">
                        {[
                            { l: 'Product Line', v: this.state.InfoProdLine.Name },
                            { l: 'Total Items', v: this.state.InfoProdLine.TotalItem },
                            { l: 'Counted', v: this.state.InfoProdLine.TotalCountItem },
                            { l: 'OK Items', v: this.state.InfoProdLine.TotalOKItem },
                            { l: 'Error Items', v: this.state.InfoProdLine.TotalWrongItem },
                            { l: 'Binary Accuracy', v: pricesFormat(this.state.InfoProdLine.BinaryAccuracy) + '%' },
                            { l: '% Advance', v: pricesFormat(this.state.InfoProdLine.Advance) + '%' },
                        ].map((f, i) => (
                            <div key={i} className="pol-kv-box">
                                <span>{f.l}</span>
                                <strong>{f.v || '—'}</strong>
                            </div>
                        ))}
                    </div>

                    {/* Search + Excel */}
                    <div style={{ display: 'flex', gap: '0.75rem', marginBottom: '0.875rem', alignItems: 'center' }}>
                        <div style={{ position: 'relative', flex: 1 }}>
                            <AiOutlineSearch style={{ position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)', color: '#94A3B8' }} />
                            <input onChange={this.searchProdLineFilter} className="form-control form-control-sm" placeholder='Search by ItemCode, Description' id='searchProdLineFilter' type="text" style={{ paddingLeft: '2rem', borderRadius: '8px', border: '1.5px solid #E2E8F0' }} />
                        </div>
                        <ExcelDocument hidden={false} archname={'Items ' + this.state.InfoProdLine.Name + ' ' + getValueCookie('Company') + ' ' + getDateFromReports()} sheetname={'Items ' + this.state.InfoProdLine.Name} data={getDataSet(this.state.ProdLineFilter, ['Item Code', 'Description', 'BIN', 'System Qty', 'Real Qty', 'Sys Diff', 'MAS90 Diff', 'Sys Cost', 'MAS90 Cost', 'Valued', 'Date', 'Counted By', 'Comment'], ['ItemCode', 'Description', 'BIN', 'systemQuantity', 'realQuantity', 'difference', 'MAS90Adjustment', 'TotalAdjustment', 'MAS90AdjCost', 'TotalVal', 'date', 'countBy', 'comentary'])} />
                    </div>

                    <div className="tableFixHeadSmall">
                        <table className='table table-clean mb-0'>
                            <thead>
                                <tr className="text-center">
                                    <th onClick={() => this.OrderInformation(this.state.ProdLineFilter, 'ItemCode', this.state.order, 'ProdLineFilter')} style={{ cursor: 'pointer' }}>Item Code {sortArrows}</th>
                                    <th className="text-start">Description</th>
                                    <th>BIN</th><th>Sys Qty</th><th>Real Qty</th>
                                    <th>Sys Diff</th><th>MAS90 Diff</th>
                                    <th className="text-end">Sys Cost</th><th className="text-end">MAS90 Cost</th><th className="text-end">Valued</th>
                                    <th>Date</th><th>Counted By</th><th className="text-start">Comment</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.ProdLineFilter.map((proLine, i) => (
                                    <tr key={i} className={proLine.difference !== proLine.MAS90Adjustment ? 'status-danger' : proLine.difference !== 0 ? 'status-warning' : 'status-success'}>
                                        <td>
                                            <span style={{ background: 'rgba(37,99,235,0.08)', color: '#1e40af', border: '1px solid #BFDBFE', borderRadius: '6px', padding: '2px 7px', fontSize: '0.72rem', fontWeight: 700 }}>{proLine.ItemCode}</span>
                                        </td>
                                        <td className="text-start" style={{ fontSize: '0.875rem' }}>{proLine.Description}</td>
                                        <td className="text-center">{proLine.BIN && proLine.BIN !== 'null' ? proLine.BIN : '—'}</td>
                                        <td className="text-center">{proLine.systemQuantity}</td>
                                        <td className="text-center">{proLine.realQuantity}</td>
                                        <td className="text-center" style={{ fontWeight: 700, color: proLine.difference !== 0 ? '#DC2626' : '#059669' }}>{proLine.difference}</td>
                                        <td className="text-center" style={{ fontWeight: 700, color: proLine.MAS90Adjustment !== 0 ? '#D97706' : '#059669' }}>{proLine.MAS90Adjustment}</td>
                                        <td className="text-end">$ {NumberFormat(pricesFormat(proLine.TotalAdjustment))}</td>
                                        <td className="text-end">$ {NumberFormat(pricesFormat(proLine.MAS90AdjCost))}</td>
                                        <td className="text-end" style={{ fontWeight: 600 }}>$ {NumberFormat(pricesFormat(proLine.TotalVal))}</td>
                                        <td style={{ fontSize: '0.8rem', color: '#64748B' }}>{proLine.date ? FormatQueryReturnDate(proLine.date) : '—'}</td>
                                        <td style={{ fontSize: '0.8rem', color: '#64748B' }}>{proLine.countBy || '—'}</td>
                                        <td className="text-start" style={{ fontSize: '0.8rem', color: '#64748B' }}>{proLine.comentary || '—'}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </ModalOrders>
            </div>
        )
    }
}
